import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';
import { UserService } from 'src/app/services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Form, FormControl, Validators } from '@angular/forms';
import { PerfilComponent } from '../perfil/perfil.component';
import * as moment from 'moment';
import { forEach } from '@angular/router/src/utils/collection';
import { isNull } from 'util';
import { isEmpty } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';

declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'app-seguimiento-certificados',
  templateUrl: './seguimiento-certificados.component.html',
  styleUrls: ['./seguimiento-certificados.component.css'],
  providers: [ClaveUnicaService]
})
export class SeguimientoCertificadosComponent implements OnInit {

  public certificado_info
  public arreglo
  buscando = false
  public numSol = new FormControl('', [Validators.required]);
  public fecha_ingreso = new FormControl('', [Validators.required]);


  identity
  token

  constructor(
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private _user: UserService,
    private spinner: NgxSpinnerService,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private claveUnicaService: ClaveUnicaService
  ) {
    this.identity = this._user.getIdentity();

    if (sessionStorage.getItem('identity-domCloud')) {
      this.searchUser()
    }/* else {
      this._router.navigate(['/inicio'])
      swal({
        type: 'warning',
        text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      })
    } */
  }

  ngOnInit() {

  }

  get_certificado() {
    this.spinner.show()
    this._user.get_certificado(this.numSol.value).subscribe(response => {
      console.log(response)
      var fechax, fechaCertificado
      if (response.certificado.length > 0) {

        this.spinner.hide()
        this.certificado_info = response.certificado
        console.log(this.certificado_info)
        this.buscando = true

        var arreglox = [];

        this.certificado_info.forEach((element, index) => {

          //console.log(element.fieldData['Propiedad 2::Pro_Propie_ROL']);
          if (index == 0) {
            this.arreglo = [{
              rol: element.fieldData['Propiedad 2::Pro_Propie_ROL'],
              data: []
            }]

            arreglox.push(element.fieldData['Propiedad 2::Pro_Propie_ROL']);
            this.arreglo[index]['data'].push({
              nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
              direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
              estado: element.fieldData['TRACER_Estado_Descripcion']
            })
          } else {
            let rolactual = element.fieldData['Propiedad 2::Pro_Propie_ROL']
            if (arreglox.indexOf(rolactual) !== -1) {

              /* OK, value exists! */
              let indexActual = arreglox.indexOf(rolactual)
              //console.log(indexActual)
              //console.log("ya existe el rol dentro")

              this.arreglo[indexActual]['data'].push({
                nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
                direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
                estado: element.fieldData['TRACER_Estado_Descripcion']
              })
            } else {

              var arregl2
              arregl2 = [{
                rol: element.fieldData['Propiedad 2::Pro_Propie_ROL'],
                data: []
              }]

              arregl2[0]['data'].push({
                nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
                direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
                estado: element.fieldData['TRACER_Estado_Descripcion']
              })

              Array.prototype.push.apply(this.arreglo, arregl2);
            }
          }

        });

        //console.log(this.arreglo)


        fechax = this.certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora
        fechaCertificado = moment(fechax).format("DD/MM/YYYY");
        this.certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora = fechaCertificado

      } else {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontraron registros de certificados con ese numero de solicitud",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }

    }, error => {
      console.log(error)
    })

  }

  volver() {
    this.buscando = false
    this.numSol.setValue("")
    this.fecha_ingreso.setValue("")

  }
  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  back() {
    this._router.navigate(['/inicio'])
  }


  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._user.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._user.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          console.log(response);

        }
        if (response.register) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

        if (response.update) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }
      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

}
